const EMAIL_RE = /[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}/g;

// Three alternatives (longest first to avoid shadowing):
//   1. E.164 with separators — +CC then 2–4 groups of 2–5 digits (handles spaces between groups)
//      Covers LATAM (+52 MX, +54 AR, +56 CL, +57 CO…) and Spain with country code (+34 …)
//   2. Spanish 9-digit bare — [6-9]XX XXX XXX with or without the +34 prefix
//      Covers mobile (6XX, 7XX) and landlines (8XX, 9XX) without a country code
//   3. NANP — 10-digit North American format with optional dash/dot/space separators
const PHONE_RE =
  /(?:\+\d{1,3}(?:[\s.-]?\d{2,5}){2,4}|(?:\+?34[\s.-]?)?[6-9]\d{2}[\s.-]?\d{3}[\s.-]?\d{3}|\b\d{3}[-.\s]?\d{3}[-.\s]?\d{4}\b)/g;

export function scrubPii(value: string): string {
  return value.replace(EMAIL_RE, "[email]").replace(PHONE_RE, "[phone]");
}
